import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StatusHandler } from '../../../components'
import { fetchProvinces as fetcher } from '../slice'
import { provincesContext as context } from './context'

const NAME = 'provinces'

const ProvincesProvider = ({children}) => {
  const dispatch = useDispatch()
  const _state = useSelector(state => state[NAME])
  const { query, status, error, data, data_options } = _state

  useEffect(() => {
    if(status === 'idle') dispatch(fetcher(query))
  }, [status, dispatch, query])

  return (
    <context.Provider value={{ [NAME]: data, options: data_options }}>
      <StatusHandler
        status={status}
        error={error}
        onRetry={() => dispatch(fetcher(query))}
      >
        {children}
      </StatusHandler>
    </context.Provider>
  )
}

export { ProvincesProvider }
